import React from 'react';
import { TextInput as SourceTextInput } from '@guardian/src-text-input';
export const TextInput = ({ formField, formData, setFormData }) => (React.createElement(SourceTextInput, { "data-testid": `form-field-${formField.id}`, type: formField.type, label: formField.label, supporting: formField.description, optional: !formField.required, value: formField.id in formData ? formData[formField.id] : '', onChange: (e) => setFormData({
        ...formData,
        [formField.id]: e.target.value,
    }) }));
